import { defineMessages } from "react-intl";

export const MISSING_LABEL_SCAN_PO_CARD_LABELS = defineMessages({
  poNumber: {
    id: "po",
    defaultMessage: "PO #",
  },
});
